var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDuplicate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1932 21H7.02497C6.57971 21 6.21875 20.6391 6.21875 20.1938V7.02552C6.21875 6.58026 6.57971 6.2193 7.02497 6.2193H20.1932C20.6386 6.2193 20.9995 6.58026 20.9995 7.02552V20.1938C20.9995 20.6391 20.6386 21 20.1932 21Z",
    stroke: "#171717",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99512 14.1185H13.3684M13.3684 14.1185H16.7417M13.3684 14.1185V10.7452M13.3684 14.1185V17.4918",
    stroke: "#171717",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7807 5.87256V1.80622M15.7807 1.80622C15.7807 1.36096 15.4198 1 14.9745 1H1.80622C1.36096 1 1 1.36096 1 1.80622V14.9745C1 15.4198 1.36096 15.7807 1.80622 15.7807H5.87256M15.7807 1.80622V6.24737",
    stroke: "#171717",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicate);
export default __webpack_public_path__ + "static/media/duplicate.a949ec6f04aa182d824458a1d377db8c.svg";
export { ForwardRef as ReactComponent };